import React from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Skeleton from '@material-ui/lab/Skeleton'

import { useContactStyles } from '../common'

export const ContactFormSkeleton = () => {
  const classes = useContactStyles()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 30 }}>
      <Card>
        <CardContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <Skeleton
            animation="wave"
            height={176}
            width={176}
            variant="circle"
            className={classes.avatar}
          />
          <Skeleton animation="wave" width={40} />
          <Skeleton animation="wave" width={300} height={50} />
          <Skeleton animation="wave" width={300} height={50} />
          <Skeleton animation="wave" width={300} height={50} />
        </CardContent>
        <CardActions className={classes.actions}>
          <Skeleton animation="wave" width={200} height={60} />
        </CardActions>
      </Card>
      <Card>
        <CardContent
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Skeleton animation="wave" width={100} />
          <Skeleton animation="wave" width={300} />
          <Skeleton animation="wave" width={300} />
          <Skeleton animation="wave" width={300} />
          <Skeleton animation="wave" width={300} />
        </CardContent>
      </Card>
    </div>
  )
}
